import React, { useContext, useState, useCallback, useEffect }from 'react';

import PresentPC from 'components/pages/AddCondition/PresentPC';
import PresentSP from 'components/pages/AddCondition/PresentSP';

import PcErrorArea from 'components/molecules/PcErrorArea';
import PcSuggestList from 'components/molecules/PcSuggestList';
import SpSuggestList from 'components/molecules/SpSuggestList';

import TextInput from 'components/atoms/Input/TextInput';
import DropdownInput from 'components/atoms/Input/DropdownInput';

import { 
  useWindowDimensions,
  useDirectTransCheck,
  useIECheck,
  isFatalApiError,
  ErrorMessage,
  sortErrors,
  isSchemaValid,
  isCustomValid,
  scrollTop,
} from 'utils';

import { ekiSuggestApi, getHourSalaryApi } from 'utils/api';

import {
  CUSTOM_ERROR_MESSAGES,
  CHOICES_MAP,
  COMMENT_MAP,
  CHOICES_NAME_MAP,
  DROPDOWN_INITIAL_ITEM_MAP
} from 'utils/constant';

import AppContext from 'fluxes/context';

import {
  CHANGE_VALID,
  UPDATE_ADD_CONDITION,
} from 'fluxes/actions';

const AddCondition = ()=>{
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });

  // state
  const[ selectedEkiCd, setSelectedEkiCd ] = useState(state.ekiCd);
  const[ ekiCd, setEkiCd ] = useState(state.ekiCd);
  const[ ekiName, setEkiName ] = useState(state.ekiName);
  const[ ekiSuggestNames, setEkiSuggestNames ] = useState([]);
  const[ timerId, setTimerId ] = useState('');
  const[ modalBackIsEnable, setModalBackIsEnable ] = useState(false);
  const [ showLoading ] = useState(false);

  const [ startTime, setStartTime ] = useState(state.startTime);
  const [ endTime, setEndTime ] = useState(state.endTime);

  const [ startTimeRangeStart, setStartTimeRangeStart ] = useState(state.startTimeRangeStart);
  const [ startTimeRangeEnd, setStartTimeRangeEnd ] = useState(state.startTimeRangeEnd);
  const [ endTimeRangeStart, setEndTimeRangeStart ] = useState(state.endTimeRangeStart);
  const [ endTimeRangeEnd, setEndTimeRangeEnd ] = useState(state.endTimeRangeEnd);

  const [ overTimeRange, setOverTimeRange ] = useState(state.overTimeRange);

  const [ workingDayRange, setWorkingDayRange ] = useState(state.workingDayRange);
  const [ workingDayRangeOthers, setWorkingDayRangeOthers ] = useState(state.workingDayRangeOthers);
  const [ workingDayCmnt, setWorkingDayCmnt ] = useState(state.workingDayCmnt);

  const [ attendance, setAttendance ] = useState(state.attendance);
  const [ remoteWorkCount, setRemoteWorkCount ] = useState(state.remoteWorkCount);
  
  const [ hourSalaryMin, setHourSalaryMin ] = useState(state.hourSalaryMin);
  const [ hourSalaryMax, setHourSalaryMax ] = useState(state.hourSalaryMax);
  const [ strHourSalaryMin, setStrHourSalaryMin ] = useState(hourSalaryMin.toString());
  const [ strHourSalaryMax, setStrHourSalaryMax ] = useState(hourSalaryMax.toString());

  const [ hourSalaryApiErr, setHourSalaryApiErr ] = useState(state.hourSalaryApiErr);

  const {
    duty,
    excelSkill,
  } = state;

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
    ekiSuggestZero: initialValid,
    checkWorkTimeOverNine: initialValid,
    checkWorkTimeEqual: initialValid,
    checkOverTimeLessThan0Hour: initialValid,
    checkWorkingDayRangeLessThan0Hour: initialValid,
    checkRemoteWorkCount: initialValid,
    checkHourSalaryLessThan0Hour: initialValid,
  });

  // APIエラー
  const [ isApiError, setIsApiError ] = useState(false);

  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    ekiCd: false,
    ekiName: false,
    workTime: false,
    overTimeRange: true,
    workingDayRange: true,
    workingDayCmnt: false,
    hourSalaryMax: false,
  });
  
  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid);
  
  const dispErrors = useCallback(() => {
    const {
      schema,
      ekiSuggestZero,
      checkWorkTimeOverNine,
      checkWorkTimeEqual,
      checkOverTimeLessThan0Hour,
      checkWorkingDayRangeLessThan0Hour,
      checkRemoteWorkCount,
      checkHourSalaryLessThan0Hour,
    } = valids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...ekiSuggestZero.errorMessages,
      ...checkWorkTimeOverNine.errorMessages,
      ...checkWorkTimeEqual.errorMessages,
      ...checkOverTimeLessThan0Hour.errorMessages,
      ...checkWorkingDayRangeLessThan0Hour.errorMessages,
      ...checkRemoteWorkCount.errorMessages,
      ...checkHourSalaryLessThan0Hour.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    return errorMap;
  }, [ isShowError, valids ]);

  // 入力チェック（全体）
  useEffect(() => {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path,
      target: {
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd, 
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMax,
      },
    });
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [ 
    ekiCd,
    ekiName,
    startTime,
    endTime,
    startTimeRangeStart,
    startTimeRangeEnd, 
    endTimeRangeStart,
    endTimeRangeEnd,
    overTimeRange,
    workingDayRange,
    workingDayRangeOthers,
    workingDayCmnt,
    attendance,
    remoteWorkCount,
    hourSalaryMax,
    valid,
    path,
  ]);

  /* 相関チェック */
  // 勤務時間 9時間以上エラーチェック
  useEffect(()=>{
    const workTimeValidation = async () => {
      const startTimeConnect = startTime[0] + startTime[1];
      const endTimeConnect = endTime[0] + endTime[1];
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOverNine' ],
        target: { target: 'workTime', min: startTimeConnect, max: endTimeConnect },
      });
      // erros更新
      const newValid = { checkWorkTimeOverNine: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    workTimeValidation();
  }, [ startTime, endTime ]);

  // 勤務時間（始業時間＝終業時間の場合エラー）チェック
  useEffect(()=>{
    const workTimeValidation = async () => {
      const startTimeConnect = startTime[0] + startTime[1];
      const endTimeConnect = endTime[0] + endTime[1];
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkEqual' ],
        target: { target: 'workTime', min: startTimeConnect, max: endTimeConnect },
      });
      // erros更新
      const newValid = { checkWorkTimeEqual: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    workTimeValidation();
  }, [ startTime, endTime ]);

  // 最大残業時間 - 最小残業時間 < 0
  useEffect(()=>{
    const overTimeValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: 'overTimeRange', min: overTimeRange[0], max: overTimeRange[1] },
      });
      // erros更新
      const newValid = { checkOverTimeLessThan0Hour: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    overTimeValidation();
  }, [ overTimeRange ]);

  // 最大勤務日数 - 最小勤務日数 < 0
  useEffect(()=>{
    const workingDayRangeValidation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: 'workingDayRange', min: workingDayRange[0], max: workingDayRange[1] },
      });
      // erros更新
      const newValid = { checkWorkingDayRangeLessThan0Hour: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    workingDayRangeValidation();
  }, [ workingDayRange ]);

  // テレワーク可能選択時、テレワークの頻度 必須チェック
  useEffect(() => {
    // エラーチェックを実行.
    const remoteWorkValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRemoteWorkCount' ],
        target: {
          attendance,
          remoteWorkCount,
        },
      });
      // erros更新
      const newValid = { checkRemoteWorkCount: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    remoteWorkValidation();
  }, [ attendance, remoteWorkCount ]);

  // 最大請求金額 - 最小請求金額 < 0
  useEffect(()=>{
    const hourSalaryValidation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: 'hourSalaryMax', min: hourSalaryMin, max: hourSalaryMax },
      });
      // erros更新
      const newValid = { checkHourSalaryLessThan0Hour: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    hourSalaryValidation();
  }, [ hourSalaryMin, hourSalaryMax ]);

 

  /**
   * 初期処理
   */
  /* 駅 値有無確認 */
  /* 初期表示時のみ実行 */
  useEffect(()=>{
    // 初期表示時駅が入力済みの場合、駅サジェスト入力チェックをスキップする
    if(!!ekiCd && !!ekiName){
      const newValid = {
        ekiSuggestZero: {
          valid: true,
          errorMessages: [],
        },
      };
      setValids(org => ({ ...org, ...newValid }));
    }
  }, []);

  /* 駅、職種、スキル、請求金額(上限)が入力済みの場合、エラー表示をtrueにする */
  /* 初期表示時のみ実行 */
  useEffect(()=>{
    if(!!ekiCd && !!ekiName && !!duty && !!excelSkill && !!hourSalaryMax ) {
      if(!isShowError.hourSalaryMax) {
        setIsShowError({ ...isShowError, hourSalaryMax: true });
      }
    }
  }, []);

  /* 時給相場金額API呼び出し */
  useEffect(()=>{
    const getHourSalary = async () => {
      const getMax = (a, b)=> a > b ? a : b;
      const excelSkillMax = excelSkill.reduce(getMax);
      const skillLevel = excelSkillMax.slice(0, 1);

      const suggestHourSalary = await getHourSalaryApi({ ekiCd, duty, skillLevel }).catch(err => {
        return 0;
      });

      if(suggestHourSalary === 0) {
        setHourSalaryApiErr(CUSTOM_ERROR_MESSAGES.hourSalaryApiErr);
      } else {
        setHourSalaryApiErr('');
      };
      setHourSalaryMin(Number(suggestHourSalary));
      setStrHourSalaryMin(suggestHourSalary.toString());  
    };
    if(!!ekiCd && !!duty && !!excelSkill ) {
      getHourSalary();
    }else{
      setHourSalaryMin(Number(1750));
      setStrHourSalaryMin('1750');
    }
  }, [ ekiCd, duty, excelSkill ]);

  /* onChage */
  /*  駅入力 */
  // サジェスト表示タイマー
  const ekiSuggestTimer = async (searchText) => {
    const id = setTimeout(() => {
      ekiSuggestApi({ searchText }).then((value)=> {
        setEkiSuggestNames(value);
        // サジェストあり
        if(value.length > 0) {
          const newValid = {
            ekiSuggestZero: {
              valid: true,
              errorMessages: [],
            },
          };
          setModalBackIsEnable(true);
          setValids(org => ({ ...org, ...newValid }));
        }else{
          setModalBackIsEnable(false);
        }
      }).catch(err => {
        setModalBackIsEnable(false);
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if(isFatal) throw err;
        // 駅サジェスト0件
        if(err.response.status === 404){
          setEkiSuggestNames([]);
          // erros更新
          const newValid = {
            ekiSuggestZero: {
              valid: false,
              errorMessages: [ new ErrorMessage('ekiName', CUSTOM_ERROR_MESSAGES.ekiSuggestZero, 1) ],
            },
          };
          setValids(org => ({ ...org, ...newValid }));
        } 
        return [];
      });
      // ekiNameエラー表示開始
      if(!isShowError.ekiName) {
        setIsShowError({
          ...isShowError,
          ...{
            ekiName: true,
            ekiCd: true,
          },
        });
      }
    }, 200, searchText);
    return id;
  };

  // 駅名入力時
  const onChangeEkiname = async (e) => {
    // safariのdeleteCompositionTextを無視
    if(e.nativeEvent.inputType === 'deleteCompositionText' || e.nativeEvent.inputType === 'insertFromComposition'){
      return;
    }
    const searchText = e.target.value;
    setEkiName(searchText);
    setEkiCd('');
    setSelectedEkiCd('');
    // 先行タイマー停止
    clearTimeout(timerId);
    // タイマー設定
    setTimerId(await ekiSuggestTimer(searchText));
  };

  // 駅サジェストクリック時
  const onClickEkiSuggest = async ( idx ) => {
    const clicked = ekiSuggestNames[idx];
    setEkiName(clicked.ekiNm);
    setEkiCd(clicked.ekiCd);
    setSelectedEkiCd(clicked.ekiCd);
    setEkiSuggestNames([]);
    setModalBackIsEnable(false);
  };

  // 勤務時間 始業
  const onChangeStartTimeHour = (value)=>{
    setStartTime(startTime.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  const onChangeStartTimeMinute = (value)=>{
    setStartTime(startTime.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  // 勤務時間 終業
  const onChangeEndTimeHour = (value)=>{
    setEndTime(endTime.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  const onChangeEndTimeMinute = (value)=>{
    setEndTime(endTime.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };

  // 始業時間の調整可能範囲
  const onChangeStartTimeRangeStartHour = (value)=>{
    setStartTimeRangeStart(startTimeRangeStart.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeStartTimeRangeStartMinute = (value)=>{
    setStartTimeRangeStart(startTimeRangeStart.map((list, index) => (index === 1 ? value : list)));
  };
  const onChangeStartTimeRangeEndHour = (value)=>{
    setStartTimeRangeEnd(startTimeRangeEnd.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeStartTimeRangeEndMinute = (value)=>{
    setStartTimeRangeEnd(startTimeRangeEnd.map((list, index) => (index === 1 ? value : list)));
  };

  // 終業時間の調整可能範囲
  const onChangeEndTimeRangeStartHour = (value)=>{
    setEndTimeRangeStart(endTimeRangeStart.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeEndTimeRangeStartMinute = (value)=>{
    setEndTimeRangeStart(endTimeRangeStart.map((list, index) => (index === 1 ? value : list)));
  };
  const onChangeEndTimeRangeEndHour = (value)=>{
    setEndTimeRangeEnd(endTimeRangeEnd.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeEndTimeRangeEndMinute = (value)=>{
    setEndTimeRangeEnd(endTimeRangeEnd.map((list, index) => (index === 1 ? value : list)));
  };

  // 月の想定残業時間
  const onChangeOverTimeRangeStart = (value)=>{
    setOverTimeRange(overTimeRange.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeOverTimeRangeEnd = (value)=>{
    setOverTimeRange(overTimeRange.map((list, index) => (index === 1 ? value : list)));
  };

  // 勤務日数の調整可能範囲
  const onChangeWorkingDayRangeStart = (value)=>{
    setWorkingDayRange(workingDayRange.map((list, index) => (index === 0 ? value : list)));
  };
  const onChangeWorkingDayRangeEnd = (value)=>{
    setWorkingDayRange(workingDayRange.map((list, index) => (index === 1 ? value : list)));
  };

  const onChangeWorkingDayRangeOthers = () =>{
    if (workingDayRangeOthers) {
      setWorkingDayRangeOthers(false);
      setWorkingDayCmnt('');
    } else {
      setWorkingDayRangeOthers(true);
      setWorkingDayRange(['', '']);
    } 
  };
  const onChangeWorkingDayCmnt = (e) => {
    setWorkingDayCmnt(e.target.value);
    if(!isShowError.workingDayCmnt) {
      setIsShowError({ ...isShowError, workingDayCmnt: true });
    }
  };

  // 勤務条件
  const onChangeAttendance = (e) => {
    const val = e.target.value;
    if (attendance.includes(val)) {
      setAttendance(attendance.filter((item) => item !== val));
    } else {
      setAttendance([ ...attendance, val ]);
    }
    if(!attendance.includes('03')){
      setRemoteWorkCount('');
    }
  };
  // テレワークの頻度
  const onChangeRemoteWorkCount = (e) => {
    setRemoteWorkCount(e.target.value);
  };

  // 請求金額
  // Maxが0の場合プレースホルダーを表示する
  useEffect(()=>{
    if(hourSalaryMax === 0){
      setStrHourSalaryMax('');
    }
  }, [ hourSalaryMax ]);

  const onChangeHourSalaryMax = (e) => {
    setStrHourSalaryMax(e.target.value);
    setHourSalaryMax(Number(e.target.value));
    if(!isShowError.hourSalaryMax) {
      setIsShowError({ ...isShowError, hourSalaryMax: true });
    }
  };


  /* プルダウン プレースホルダーのセット start */
  // 勤務時間 始業
  const startTimeHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeHour, ...CHOICES_MAP.hourList];
  const startTimeMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeMinute, ...CHOICES_MAP.minuteList];

  // 勤務時間 終業
  const endTimeHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeHour, ...CHOICES_MAP.hourList];
  const endTimeMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeMinute, ...CHOICES_MAP.minuteList];

  // 始業時間の調整可能範囲
  const startTimeRangeStartHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeStartHour, ...CHOICES_MAP.hourList];
  const startTimeRangeStartMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeStartMinute, ...CHOICES_MAP.minuteList];

  const startTimeRangeEndHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeEndHour, ...CHOICES_MAP.hourList];
  const startTimeRangeEndMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeEndMinute, ...CHOICES_MAP.minuteList];

  // 終業時間の調整可能範囲
  const endTimeRangeStartHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeStartHour, ...CHOICES_MAP.hourList];
  const endTimeRangeStartMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeStartMinute, ...CHOICES_MAP.minuteList];

  const endTimeRangeEndHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeEndHour, ...CHOICES_MAP.hourList];
  const endTimeRangeEndMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeEndMinute, ...CHOICES_MAP.minuteList];

  // 月の想定残業時間
  const overTimeRangeMinList = [DROPDOWN_INITIAL_ITEM_MAP.overTimeMin, ...CHOICES_MAP.overTimeHourList];
  const overTimeRangeMaxList = [DROPDOWN_INITIAL_ITEM_MAP.overTimeMax, ...CHOICES_MAP.overTimeHourList];

  // 勤務日数の調整可能範囲
  const workingDayRangeMinList = [DROPDOWN_INITIAL_ITEM_MAP.workingDayRangeMin, ...CHOICES_MAP.workingDayRangeList];
  const workingDayRangeMaxList = [DROPDOWN_INITIAL_ITEM_MAP.workingDayRangeMax, ...CHOICES_MAP.workingDayRangeList];
  /* プルダウン プレースホルダーのセット end */

  /* 表示項目 */
  const ekiDisp = {
    title: '派遣先最寄り駅',
    subTitle: '派遣スタッフ就業先の最寄り駅を選択してください。なお、一部地域については、対応できない場合がございます。',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <TextInput
        name='ekiName'
        val={ekiName}
        onChange={onChangeEkiname}
        placeholder='駅名'
        inValid={!!dispErrors().ekiName}
        suggestText
      />
      <PcErrorArea position='custom' message={dispErrors().ekiName} />
      {/* 駅サジェストエリア */}
      <div className="searchNamesWrapper">
        <div className="searchNames">
          {isSp ? (
            <SpSuggestList
              items={ekiSuggestNames.map(x => x.ekiNm)}
              onClick={onClickEkiSuggest}
            />
          ) : (
            <PcSuggestList
              items={ekiSuggestNames.map(x => x.ekiNm)}
              onClick={onClickEkiSuggest}
              fullWidth
            />
          )}
        </div>
      </div>
    </>,
  };

  const startTimeDisp = {
    title: '勤務時間',
    subTitle: '実働8時間以内（休憩1時間の場合、始業時間から終業時間まで9時間以内）で入力してください。',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <div className='workTime'>
        <span className='workTime_DB'>
          <DropdownInput
            items={startTimeHourList}
            selectedValue={startTime[0]}
            onChange={onChangeStartTimeHour}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>時</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={startTimeMinuteList}
            selectedValue={startTime[1]}
            onChange={onChangeStartTimeMinute}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>分</label> {isSp ? <br /> : <></>}
        <label>～</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={endTimeHourList}
            selectedValue={endTime[0]}
            onChange={onChangeEndTimeHour}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>時</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={endTimeMinuteList}
            selectedValue={endTime[1]}
            onChange={onChangeEndTimeMinute}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>分</label>
        <span className='AddCondition_ERR'>
          <PcErrorArea position='absolute' message={dispErrors().workTime} />
        </span>
      </div>
    </>
  };

  const startTimeRangeDisp = {
    id: 'startTimeRange',
    title: '始業時間の調整可能範囲',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <div className='startTimeRange'>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeStartHourList}
            selectedValue={startTimeRangeStart[0]}
            onChange={onChangeStartTimeRangeStartHour}
            isOpen={false}
          />
        </span>
        <label>時</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeStartMinuteList}
            selectedValue={startTimeRangeStart[1]}
            onChange={onChangeStartTimeRangeStartMinute}
            isOpen={false}
          />
        </span>
        <label>分</label> {isSp ? <br /> : <></>}
        <label>～</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeEndHourList}
            selectedValue={startTimeRangeEnd[0]}
            onChange={onChangeStartTimeRangeEndHour}
            isOpen={false}
          />
        </span>
        <label>時</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeEndMinuteList}
            selectedValue={startTimeRangeEnd[1]}
            onChange={onChangeStartTimeRangeEndMinute}
            isOpen={false}
          />
        </span>
        <label>分</label>
      </div>
    </>
  };
  
  const endTimeRangeDisp = {
    id: 'endTimeRange',
    title: '終業時間の調整可能範囲',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <div className='endTimeRange'>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeStartHourList}
            selectedValue={endTimeRangeStart[0]}
            onChange={onChangeEndTimeRangeStartHour}
            isOpen={false}
          />
        </span>
        <label>時</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeStartMinuteList}
            selectedValue={endTimeRangeStart[1]}
            onChange={onChangeEndTimeRangeStartMinute}
            isOpen={false}
          />
        </span>
        <label>分</label> {isSp ? <br /> : <></>}
        <label>～</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeEndHourList}
            selectedValue={endTimeRangeEnd[0]}
            onChange={onChangeEndTimeRangeEndHour}
            isOpen={false}
          />
        </span>
        <label>時</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeEndMinuteList}
            selectedValue={endTimeRangeEnd[1]}
            onChange={onChangeEndTimeRangeEndMinute}
            isOpen={false}
          />
        </span>
        <label>分</label>
      </div>
    </>
  };

  const overTimeRangeDisp = {
    id: 'overTimeRange',
    title: '月の想定残業時間',
    subTitle: '所定時間外についての残業時間を選択してください。',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <div className='overTimeRange'>
        <span className='overTimeRange_DB'>
          <DropdownInput
            items={overTimeRangeMinList}
            selectedValue={overTimeRange[0]}
            onChange={onChangeOverTimeRangeStart}
            isOpen={false}
            inValid={!!dispErrors().overTimeRange}
          />
        </span>
        <label>時間</label>
        <label>～</label>
        <span className='overTimeRange_DB'>
          <DropdownInput
            items={overTimeRangeMaxList}
            selectedValue={overTimeRange[1]}
            onChange={onChangeOverTimeRangeEnd}
            isOpen={false}
            inValid={!!dispErrors().overTimeRange}
          />
        </span>
        <label>時間</label>
        <span className='AddCondition_ERR'>
          <PcErrorArea position='absolute' message={dispErrors().overTimeRange} />
        </span>
      </div>
    </>
  };

  const workingDayRangeDisp = {
    id: 'workingDayRange',
    title: '勤務日数の調整可能範囲',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: <>
      <div className='workingDayRange'>
        <label className='syuu'>平日週</label>
        <span className='workingDayRange_DB'>
          <DropdownInput
            items={workingDayRangeMinList}
            selectedValue={workingDayRange[0]}
            disabled={workingDayRangeOthers}
            onChange={onChangeWorkingDayRangeStart}
            isOpen={false}
            inValid={!!dispErrors().workingDayRange}
          />
        </span>
        <label>日</label>
        <label>～</label>
        <span className='workingDayRange_DB'>
          <DropdownInput
            items={workingDayRangeMaxList}
            selectedValue={workingDayRange[1]}
            disabled={workingDayRangeOthers}
            onChange={onChangeWorkingDayRangeEnd}
            isOpen={false}
            inValid={!!dispErrors().workingDayRange}
          />
        </span>
        <label>日</label>
        <div className='AddCondition_ERR'>
          <PcErrorArea position='' message={dispErrors().workingDayRange} />
        </div>
      </div>
    </>
  };

  
  const workingDayRangeOthersDisp = {
    value: workingDayRangeOthers,
    label: 'その他（シフト勤務など）',
    onChange: onChangeWorkingDayRangeOthers,
    checked: workingDayRangeOthers,
    id: 'workingDayRangeOthersCmnt',
    comment: {
      title: COMMENT_MAP.workingDayRangeOthersCmnt.title,
      label: CHOICES_NAME_MAP.require,
      name: 'workingDayRangeOthersCmnt',
      textAreaValue: workingDayCmnt,
      cmntOnChange: onChangeWorkingDayCmnt,
      onInput: onChangeWorkingDayCmnt,
      onCompositionEnd: onChangeWorkingDayCmnt,
      maxLength: '500',
      placeholder: COMMENT_MAP.workingDayRangeOthersCmnt.placeholder,
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      visible: workingDayRangeOthers,
      questionMark: false,
      popUpTitle: null,
      popUpDetail: null,
      inValid: dispErrors().workingDayCmnt,
      errMessage: dispErrors().workingDayCmnt,
    },
  };
  
  const attendanceDisp = {
    title: '該当する場合はチェックをつけてください',
    label: CHOICES_NAME_MAP.option,
    list: CHOICES_MAP.attendanceList.map((elem) => {
      const infoStr = 'attendance';
      return {
        id: infoStr + elem.value,
        value: elem.value,
        onChange: onChangeAttendance,
        checked: attendance ? attendance.includes(elem.value) : false,
        label: elem.label,
        name: infoStr,
        number: isSp ? 2 : 3.04, // 3列になるように調整
      };
    }),
    type: 'CheckBoxChildInput',
    childInput: attendance.includes('03') ? {
      title: 'テレワークの頻度を選択してください',
      label: CHOICES_NAME_MAP.require,      
      type: 'RadioInput',
      visible: attendance ? attendance.includes('03') : false,
      list: CHOICES_MAP.remoteWorkCountList.map((elem) => {
        const infoStr = 'remoteWorkCount';
        return {
          value: elem.value,
          label: elem.label,
          id: infoStr + elem.value,
          onChange: onChangeRemoteWorkCount,
          checked: remoteWorkCount ? remoteWorkCount.includes(elem.value) : false,
          name: infoStr,
          number: isSp ? null : 3, // 3列になるように調整
        };
      }),
    } : null,
  };

  const hourSalaryDisp = {
    title: '請求金額',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    input: {
      hourSalaryMin: strHourSalaryMin,
      hourSalaryMax: strHourSalaryMax,
      onChangeHourSalaryMax,
      placeholder: '金額を入力してください',
      inValid: dispErrors().hourSalaryMax,
      apiErrMessage: hourSalaryApiErr,
    },
  };

  const DispList1 = [
    ekiDisp,
    startTimeDisp,
  ];

  const DispList2 = [
    startTimeRangeDisp,
    endTimeRangeDisp,
    overTimeRangeDisp,
    workingDayRangeDisp,
  ];

  /* ボタン押下時 */
  // state更新処理
  const updateAddConditionState = () => {
    dispatch({
      type: UPDATE_ADD_CONDITION,
      updAddCondition: {
        ekiCd: selectedEkiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd, 
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,
        hourSalaryApiErr,
      },
    });
  };
  const onClickMainButton = {
    prev: () => {
      scrollTop();
      updateAddConditionState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
    next: () => {
      scrollTop();
      updateAddConditionState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
  };

  return isSp ? (
    <PresentSP
      // state
      DispList1={DispList1}
      DispList2={DispList2}
      workingDayRangeOthersDisp={workingDayRangeOthersDisp}
      attendanceDisp={attendanceDisp}
      hourSalaryDisp={hourSalaryDisp}

      // onChange
      modalBackIsEnable={modalBackIsEnable}

      // onClick
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      showLoading={showLoading}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    />
  ) : (
    <PresentPC
      // state
      DispList1={DispList1}
      DispList2={DispList2}
      workingDayRangeOthersDisp={workingDayRangeOthersDisp}
      attendanceDisp={attendanceDisp}
      hourSalaryDisp={hourSalaryDisp}

      // onChange
      modalBackIsEnable={modalBackIsEnable}

      // onClick
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      showLoading={showLoading}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    />
  );
};

export default AddCondition;